import { useTenant } from "../../Contexts/TenantContext";
import { formatPriceBRL } from "../../Utils/DataFormatters";
import { FaCreditCard, FaLock, FaTruck } from "react-icons/fa";
import { GiBrazil } from "react-icons/gi";

const TrustBar = () => {
  const { tenantPreference, tenantShippingProviderConfig } = useTenant();
  const hasFreeShipping = tenantShippingProviderConfig?.offerFreeShipping ?? false;
  const hasCorreiosContract = tenantShippingProviderConfig?.hasCorreiosContract ?? false;
  const offerNoInterest = tenantPreference?.offerCardNoInterest ?? false;
  const maxInstallments = offerNoInterest
    ? tenantPreference?.cardMaxNoInterestInstallments
    : 12;
  const freeShippingThreshold = tenantShippingProviderConfig?.minOrderSubtotalForFreeShipping ?? null;

  const paymentTitle = offerNoInterest
    ? "Parcele suas compras"
    : "Pague parcelado";
  const paymentSubtitle = offerNoInterest
    ? `Em até ${maxInstallments}x sem juros`
    : `Em até ${maxInstallments}x no cartão de crédito`;

  const shippingTitle = hasCorreiosContract
    ? "Entregamos"
    : "Envio combinado";
  const shippingSubtitle = hasCorreiosContract
    ? "Em todo o Brasil"
    : "Consulte disponibilidade";

  const freeShippingSubtitle = freeShippingThreshold
    ? `A partir de ${formatPriceBRL(freeShippingThreshold)}`
    : "Confira condições";

  return (
    <div className="bg-primary-600 text-white py-12">
      <div className="max-w-[94rem] mx-auto px-6">
      <h2 className="text-2xl font-semibold text-center mb-8">
        {"Compras na loja"}
      </h2>
      {/* Mobile: 2-col grid (icon | text) so icons align. Desktop: flex row. */}
      <div className="flex justify-center sm:hidden">
      <div className="grid grid-cols-[2.5rem_1fr] gap-x-5 gap-y-8 text-sm">
        <div className="flex items-center justify-center"><FaCreditCard className="text-4xl" /></div>
        <div className="flex flex-col justify-center"><p>{paymentTitle}</p><p>{paymentSubtitle}</p></div>

        <div className="flex items-center justify-center">
          {hasFreeShipping ? <GiBrazil className="text-4xl" /> : <FaTruck className="text-4xl" />}
        </div>
        <div className="flex flex-col justify-center"><p>{shippingTitle}</p><p>{shippingSubtitle}</p></div>

        {hasFreeShipping ? (
          <>
            <div className="flex items-center justify-center"><FaTruck className="text-4xl" /></div>
            <div className="flex flex-col justify-center"><p>{"Frete Grátis"}</p><p>{freeShippingSubtitle}</p></div>
          </>
        ) : (
          <>
            <div className="flex items-center justify-center"><FaLock className="text-4xl" /></div>
            <div className="flex flex-col justify-center"><p>{"Loja 100% segura"}</p><p>{"Seus dados protegidos"}</p></div>
          </>
        )}
      </div>
      </div>

      <div className="hidden sm:flex text-sm justify-between items-center text-left gap-8">
        <div className="flex items-center gap-5">
          <div className="w-10 h-10 flex items-center justify-center"><FaCreditCard className="text-4xl" /></div>
          <div><p>{paymentTitle}</p><p>{paymentSubtitle}</p></div>
        </div>
        <div className="flex items-center gap-5">
          <div className="w-10 h-10 flex items-center justify-center">
            {hasFreeShipping ? <GiBrazil className="text-4xl" /> : <FaTruck className="text-4xl" />}
          </div>
          <div><p>{shippingTitle}</p><p>{shippingSubtitle}</p></div>
        </div>
        {hasFreeShipping ? (
          <div className="flex items-center gap-5">
            <div className="w-10 h-10 flex items-center justify-center"><FaTruck className="text-4xl" /></div>
            <div><p>{"Frete Grátis"}</p><p>{freeShippingSubtitle}</p></div>
          </div>
        ) : (
          <div className="flex items-center gap-5">
            <div className="w-10 h-10 flex items-center justify-center"><FaLock className="text-4xl" /></div>
            <div><p>{"Loja 100% segura"}</p><p>{"Seus dados protegidos"}</p></div>
          </div>
        )}
      </div>
      </div>
    </div>
  );
};

export default TrustBar;
